// extracted by mini-css-extract-plugin
module.exports = {"container":"_lU","title":"_lV","image":"_lW","imageLogo":"_lX","info":"_lY","infoContainer":"_lZ","infoTitle":"_l0","infoValue":"_l1","goBack":"_l2"};